import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const getComputeClusterTE = <E = CF.API.ApiError>(
  { userId, computeClusterId, params = '', sessionToken }: { userId: string; computeClusterId: string; params?: string; sessionToken?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ComputeClusterResponse> =>
  fetchTE<CF.API.Compute.ComputeClusterResponse, E>(
    {
      path: `/api/_api/v2${userId ? `/users/${userId}` : ''}/compute_clusters/${computeClusterId}${params ? `?${params}` : ''}`,
      method: 'GET',
      sessionToken,
    },
    onRejected,
  );
